module.exports = __webpack_public_path__ + "img/pc-button-text-right-02.fcb8e979.svg";